import type { ReactNode } from 'react';
import { I18nProvider } from '../i18n';
import { CompanyFilterProvider } from './company';
import { TopbarProvider } from './topbar';
import { UiProvider } from './ui';

/** Všechny aplikační providery kromě QueryClient a routeru (ty dodává main.tsx / testy). */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <I18nProvider>
      <UiProvider>
        <CompanyFilterProvider>
          <TopbarProvider>{children}</TopbarProvider>
        </CompanyFilterProvider>
      </UiProvider>
    </I18nProvider>
  );
}
